module.exports = __webpack_public_path__ + "static/img/rest41.890c036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest41.jpg
// module id = Q31Q
// module chunks = 0